<template>
	<div>
		<!-- Label -->
		<div class="flex xs-12 xs-between">
			<label class="fs3 c6 fw6 mb1">{{ $t("source") }}</label>
			<div v-if="value.length > 0" class="fs3 cu2 cError" @click="handleReset">
				{{ $t("clear") }}
			</div>
		</div>

		<j-base-multi-select-with-flexible-value
			:value="value"
			:allowSearch="false"
			:options="options"
			:size="size"
			:placeholder="$t('select')"
			@input="$emit('input', $event)"
		/>
	</div>
</template>

<script>
import JBaseMultiSelectWithFlexibleValue from "@/components/JBaseMultiSelectWithFlexibleValue/"
import { sources } from "@/forms/enums.js"

export default {
	components: { JBaseMultiSelectWithFlexibleValue },
	props: ["value", "size"],

	data() {
		return {}
	},

	computed: {
		options() {
			return sources
		}
	},

	methods: {
		handleReset() {
			this.$emit("input", [])
		}
	}
}
</script>
